import { Avatar, Popconfirm } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import UserAvatar from "../UserAvatar";

/**
 * The roster strip that sits in a page header.
 *
 * It existed three times — both dashboards and the users performance report —
 * and the report's copy had drifted: raw antd `Avatar`s with a generic person
 * glyph, so everyone without a photo was the same grey circle, at a different
 * size, opening a tooltip instead of a way through to the profile. One
 * component now, so the same people look the same wherever they are listed.
 *
 * `users` takes the dropdown option shape the pages already build
 * (`{ label, value, avatar }`) rather than raw user models, because that is
 * what every caller has in hand.
 */
const UserAvatarGroup = ({ users = [], maxCount = 6, size = 32 }) => {
  const navigate = useNavigate();

  return (
    <Avatar.Group maxCount={maxCount} size={size}>
      {users.map((usr) => (
        <Popconfirm
          key={usr?.value}
          title={usr?.label}
          okText="مشاهده پروفایل"
          icon={<UserOutlined />}
          trigger="hover"
          showCancel={false}
          onConfirm={(e) => {
            e.stopPropagation();
            navigate(`/users/edit/${usr.value}`);
          }}
        >
          <UserAvatar
            user={{
              uuid: String(usr?.value),
              name: usr?.label,
              avatar: usr?.avatar ? { original_url: usr.avatar } : null,
            }}
            size={size}
          />
        </Popconfirm>
      ))}
    </Avatar.Group>
  );
};

export default UserAvatarGroup;
